import {
  EMPTY_FUNCTION,
  EMPTY_FUNCTION_ASYNC,
} from '../../../../constants/common'
import { UserProfileContextProvider } from '../../../User'
import { UserProfilePageActionsWidget } from '../../../UserProfilePage'
import { Container } from '../../Container'

import { PROFILE_ACTIONS_WIDGET_INHABITANT_VARIANTS } from './ProfileActionsWidgetInhabitant.constants'

function ProfileActionsWidgetInhabitant() {
  return PROFILE_ACTIONS_WIDGET_INHABITANT_VARIANTS.map(
    ({ inhabitantData, label }) => (
      <Container key={label} label={label}>
        <UserProfileContextProvider
          isInitiated
          handleCloseModal={EMPTY_FUNCTION}
          handleEntityReload={EMPTY_FUNCTION_ASYNC}
          handleReloadTabs={EMPTY_FUNCTION_ASYNC}
          handleUpdateEntity={EMPTY_FUNCTION_ASYNC}
          isLoading={false}
          isPerformingAction={false}
          setModal={EMPTY_FUNCTION}
          setPerformingAction={EMPTY_FUNCTION}
          userData={inhabitantData}
        >
          <UserProfilePageActionsWidget />
        </UserProfileContextProvider>
      </Container>
    )
  )
}

export default ProfileActionsWidgetInhabitant
